<template>
    <div class="field has-addons">
        <div class="control is-expanded">
            <input v-model="beneficiaryID" class="input" type="number" inputmode="numeric"
                placeholder="Beneficiary Card Number">
        </div>
        <div class="control">
            <button :disabled="!beneficiaryID" @click="searchBeneficiaryByID()" class="button is-info">
                Search
            </button>
        </div>
    </div>
    <base-spinner v-if="isLoading"></base-spinner>
    <div v-if="beneficiaries != undefined && beneficiaries.length != 0" class="align-center">
        <BeneficiaryResult v-for="beneficiary in beneficiaries" :key="beneficiary.id" :id="beneficiary.id"
            :isBeneficiaryActive="beneficiary.active" :nric="beneficiary.nric" :beneficiaryName="beneficiary.full_name"
            :selfCollection="beneficiary.self_collection" :drivingDelivery="beneficiary.driving_delivery"
            :unit="beneficiary.unit" :block="beneficiary.block" :street="beneficiary.street">
        </BeneficiaryResult>
        <div v-if="!isRegistrationDone">
            <div class="block">
                <input v-model="note" class="input is-rounded" placeholder="Name">
                <input v-model="gender" class="input is-rounded" placeholder="Gender">
                <input v-model="yearOfBirth" class="input is-rounded" placeholder="Year of Birth">
            </div>
            <div @click="register()" :class="[isRegisterButtonLoading ? 'is-loading' : '']"
                class="button is-primary is-rounded">
                Register for this event
            </div>
        </div>
        <div v-else class="notification is-info">
            Registration completed!
        </div>
    </div>
    <div v-else-if="searched" class="notification is-danger is-light">
        No Beneficiary found with this ID.
    </div>
    <div v-if="!!error" class="notification is-danger is-light">
        <p>{{ error }}</p>
    </div>
</template>

<script>
import BeneficiaryResult from '../../components/beneficiary/BeneficiaryResult.vue';

export default {
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            beneficiaryID: null,
            registerID: null,
            searched: false,
            isLoading: false,
            isRegisterButtonLoading: false,
            isRegistrationDone: false,
            error: null,
            note: null
        }
    },
    components: {
        BeneficiaryResult
    },
    computed: {
        beneficiaries() {
            return this.$store.getters['beneficiary/getBeneficiaries'];
        }
    },
    methods: {
        async searchBeneficiaryByID() {
            this.error = null;
            this.isLoading = true;
            this.isRegistrationDone = false;
            try {
                await this.$store.dispatch('beneficiary/loadBeneficiaries', {
                    searchBy: "id",
                    searchTerm: this.beneficiaryID
                });
            } catch (error) {
                this.error = error.message || 'Something went wrong!';
            }
            this.isLoading = false;
            this.searchPerformed = true;
            this.registerID = this.beneficiaryID;
            this.beneficiaryID = null;
            this.searched = true;
            this.note = null;
        },
        async register() {
            this.isRegisterButtonLoading = true;
            try {
                await this.$store.dispatch('events/registerBeneficiaryForEvent', {
                    eventID: this.id,
                    beneficiaryID: this.registerID,
                    note: this.note,
                    name: this.beneficiaries[0].full_name,
                    yearOfBirth: this.yearOfBirth,
                    gender: this.gender
                });
            } catch (error) {
                this.error = error.message || 'Something went wrong!';
                console.error(error);
            }
            this.isRegisterButtonLoading = false;
            this.isRegistrationDone = true;
        }
    }
}
</script>